import { filter, take } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { InboxSortService, UserInfoService, IntimationService, ClaimRegistrationService, LookupDataService } from '../../../../BaseFramework/core/http';
import * as moment from 'moment/moment';
import { MetadataService } from '../../../../BaseFramework/core/http/metadata.service';
import {
  InteractService, AppMetadataHandler, CommonUtilty, ApiRequestService,
  WorkqueueService
} from 'app'
import { Router, ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ArrayManipulations } from 'app/BaseFramework/core/utilities/arrayManipulations';
import { of } from 'rxjs';
import { environment } from 'environments/environment';
import { DataTransformService } from 'app/ViewModules/shared-services/data-transform/data-transform.service';
import { SessionTimeoutService } from 'app/BaseFramework/core/services/session/session-timeout.service';
import { OrderByPipe } from 'app/BaseFramework/shared/custom-pipes';
import * as XLSX from 'xlsx';
import { PersonalisedInobxService } from 'app/BaseFramework/core/services/personalized-inbox/personalised-inobx.service';
import * as jsep from 'jsep';
import { TechnicalTranslatePipe } from 'app/BaseFramework/shared/custom-pipes';
import { MultiLingualService } from 'app';
import { Constants } from '../../../../../app/constants';

const jsep1 = require('jsep');

import { CurrencyFormatterPipe } from 'app/BaseFramework/shared/custom-pipes';
import { TaskService } from 'app/BaseFramework/core/http/task.service';
import { PolicyService } from 'app/FunctionalModules';
class SearchAPIMetaDataDO {
  key: any;
  keyDescription: any;
  valueInputType: any;
  lookupName: any;
  lookup: any;
  enable: true;
  isMandatory: Boolean;
  defaultFl: any;
}



type FilterRule = string | null;

interface Claim {
  [key: string]: any;
}

interface FolderConfig {
  icon: any;
  title: any;
  key: any;
  expanded: Boolean;
  parentQueueCd: any;
  isLeaf: Boolean;
  count: any;
  children: any;
  routeRule: any;
}

interface FilteredResult {
  filteredClaims: Claim[];
  messages: string[];
  children?: { [key: string]: FilteredResult };
  sortOrder: number // Change this line to define children correctly
}

class WorkQueTreeDO {
  icon: any;
  title: any;
  key: any;
  expanded: Boolean;
  parentQueueCd: any;
  isLeaf: Boolean;
  count: any;
  children: any = [];
}
class ExtraFolderTreeDO {
  icon: any;
  title: any;
  key: any;
  expanded: Boolean;
  parentQueueCd: any;
  isLeaf: Boolean;
  count: any;
  children: any = [];
  routeRule: any;
  sortOrder: number;
}
class InboxAttributeDO {
  key: any;
  value: any;
  description: any;
  isVisible: Boolean;
}
interface InboxAttributes {
  key: string,
  description: string,
  isVisible: boolean,
  pipe?: string,
  date?: boolean,
  formatter?: any;
  isSelected?: boolean;
}

@Component({
  selector: 'app-workbench',
  templateUrl: './workbench.component.html',
  styleUrls: ['./workbench.component.scss'],
  providers: [OrderByPipe, CurrencyFormatterPipe, TechnicalTranslatePipe]
})
export class WorkbenchComponent implements OnInit {
  public searchResultList = []
  public workQueueAPIResponse: any[] = null;
  public fakeLoadingCards = [1, 2, 3]
  public CRITERIALOOKUP = [];
  public sortCriteria: any = '';
  public _subscription: any;
  public MetaDataMapdummy: any
  public _inboxType: any = null
  public env = environment
  public openMigratedClaimModal = false;

  /*Count down code variables*/
  timed: boolean = false;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  countdown: any;
  modShowReassign: boolean = false;
  modShowReassing: boolean = false;
  openConfirmationModal: boolean = false;
  inboxDataPointsSuperSet: Array<InboxAttributes> = [];
  inboxDataPointsDefaultSet: Array<InboxAttributes> = [];
  analyticsModal: boolean = false;
  activityModal: boolean = false;
  analyticsWorkQueueItemData = {};
  activityWorkQueueItemData = {};
  impTaskCount = {};
  loadCasesSummaryPanel: boolean = true;
  constants = Constants;

  constructor(
    private workQueueService: WorkqueueService,
    private message: NzMessageService,
    private inboxSortService: InboxSortService,
    private metadataService: MetadataService,
    private userInfoService: UserInfoService,
    private interactService: InteractService,
    private router: Router,
    public appMetadataHandler: AppMetadataHandler,
    private activatedRoute: ActivatedRoute,
    private notification: NzNotificationService,
    private commonUtilty: CommonUtilty,
    private arrayManipulations: ArrayManipulations,
    public dataTransformService: DataTransformService,
    public sessionTimeoutService: SessionTimeoutService,
    private orderByPipe: OrderByPipe,
    private personalisedInobxService: PersonalisedInobxService,
    public lookupDataService: LookupDataService,
    private currencyFormatterPipe: CurrencyFormatterPipe,
    private technicalTranslate: TechnicalTranslatePipe,
    public multiLingualService: MultiLingualService,
    private policyService: PolicyService
  ) { }

  ngOnInit() {

    this.interactService.refreshTaskSubject$.next('yes')
    this.activatedRoute.data.subscribe(data => {
      this._inboxType = data['inboxType']
      this.inboxFullPrivilege = !!!(this._inboxType == 'partner-inbox')

    });
    this.randomizeList();
    this.getAllCardsData();
    this.metadataService.getSearchCriteriaList('searchInboxNbu').subscribe(resp => {
      this.CRITERIALOOKUP = this.commonUtilty.deepCopy(resp)
    });
    this.sortCriteria = this.inboxSortService.sortCondition;
    let me = this
    this._subscription = this.inboxSortService.sortConditionChange.subscribe((value) => {
      me.sortCriteria = value;
    })
    if (this.userInfoService.getUserName() != "no-user") {
      this.userName = this.userInfoService.getUserName();
      let userId = this.userInfoService.getUserId();
      this.currentUser = userId;
    };
    this.checkTimeToGreet();
    this.refreshReassingTaskList();
    this.setExtraFolderWorkqueue();
    this.fieldsForSorting();
    this.productFamilyCd = this.commonUtilty.isArrayIterable(environment['lob']) ? environment['lob'][0] : 'HEALTH';
    this.fetchProducts(this.productFamilyCd);
  }

  /********Summary**********/
  getAllCardsData() {
    this.startListLoader();
    this.loadCases('myCases');
    this.loadCases('subCases', true);
    this.loadCases('teamCases', true);
  }

  setInboxCardMetaData() {
    this.MetaDataMapdummy = this.appMetadataHandler.inboxCardMetaData.default;
    this.filteredMetaDataMap = Object.assign([], this.MetaDataMapdummy).filter(
      item => item.isVisible || item.sortFilter
    )
    var defaultVal = this.filteredMetaDataMap ? this.filteredMetaDataMap.find(item => true) : null;
    this.fieldSelectedFilter = defaultVal ? defaultVal.dataKey : '';
  }

  ngOnDestroy(): void {
    this.inboxSortService.setSortCondition(null)
  }
  enableViewAllCases: boolean = false;
  optionTEMP = 0;
  isLoading = false;
  inboxViewName = null;
  radioValue = "myCases";
  workques = [];
  filteredMetaDataMap = [];
  randomizeList = function () {
    this.loadFaker();
  };

  lookupsToBind = ['roleUsers', 'csrUsers', 'claimUsersCd', 'tasks']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  subordinateDataNotReceived: any
  teamDataNotReceived: any

  loadFaker = function () {
    this.isLoading = true;
    setTimeout(() => { this.isLoading = false }, 1250);
  };

  inboxFullPrivilege = true
  searchResultCount = 10;

  fetchSearchResult($event) {
    if ($event && !$event.reset) {
      if ($event) {
        this.searchResultList = $event
        this.sortCriteria = ""
        this.workQueueAPIResponse = this.searchResultList || [];
        this.dataSet = this.workQueueAPIResponse;
        this.searchResultCount = this.searchResultList.length;
        this.setTaskCountForFolder()
        this.stopListLoader();
        this.resetPageNumber();
        this.taskList = [];
      }
      else {

      }
    }
    else {
      this.loadCases(this.radioValue);
    }
  }

  private resetPageNumber() {
    this.pageNumber = 1;
  }

  disableCasesToggle = false;
  loadCases(section: String, needCountOnly?) {
    this.resetPageNumber();
    this.startListLoader();
    console.log(section);
    if ('teamCases' == section) {
      this.inboxViewName = 'TEAMLEADTASK'
      this.getUserTeammateTasks();
    }
    else if ('subCases' == section) {
      this.inboxViewName = 'WORKQUEUEMANAGER'
      this.getUserSubordinateTasks();
    }
    else {
      this.inboxViewName = 'INDIVIDUAL'
      this.getIndivisualTasks();
    }
  }

  myCases: boolean = true;
  getCaseCategory(section) {
    this.myCases = section == 'myCases' ? true : false;
  }

 productData
 productFamilyCd
 openTransactionDetails(objectData, source?) {
    console.log("object data", JSON.stringify(objectData));
    let entityGuid = source=='grid-layout' ? objectData.entityGuid : objectData.componentData.entityGuid;
    let serviceTask = source=='grid-layout' ? objectData.serviceTask : objectData.componentData.serviceTask;
    let taskId = source=='grid-layout' ? objectData.taskId : objectData.componentData.taskId;
    let selectedProduct = source=='grid-layout' ? objectData.selectedProduct : objectData.componentData.selectedProduct;
    let selectedProductData = this.productData.find(item => item.productId === selectedProduct);
    let transactionDataIO: any = [];
    this.productFamilyCd = objectData.componentData.productFamilyCd;
    if (serviceTask == "proposal_ManualUw" || serviceTask == "REFERRALS") {
      transactionDataIO = this.fetchCaseAndPassItToTransaction(entityGuid, transactionDataIO, serviceTask, taskId, selectedProductData);
    } else if (serviceTask == "proposal_DataEntry" || serviceTask == "proposal_CounterOffer" || serviceTask == "policyAutoUWTask" || serviceTask == "MOTORproposal_DataEntry") {
      transactionDataIO = this.fetchPolicyAndPassItToTransaction(entityGuid, transactionDataIO, serviceTask, taskId,selectedProductData);
    }
  }
  
  private fetchPolicyAndPassItToTransaction(entityGuid: any, transactionDataIO: any, serviceTask: any, taskId: any,selectedProduct) {
    this.policyService.getPolicyByGuid(entityGuid).
      subscribe(resp => {
        if (resp && Object.entries(resp).length > 0) {
          transactionDataIO = resp;
          let inboxType = this._inboxType
          this.interactService.sendIOToTransaction(serviceTask, this.productFamilyCd, selectedProduct, 'SINGLELIFE', transactionDataIO, taskId, null, inboxType);
          // this.interactService.sendIOToTransaction(serviceTask, transactionDataIO, taskId, null, inboxType);
          this.router.navigate(['/app/nbu/transaction/details'], { queryParams: {}, replaceUrl: false });
        }
        else {
          this.message.error("SERVER ERROR - Technical issue occurred, please contact IT Support.")
        }
      });
    return transactionDataIO;
  }

  private fetchCaseAndPassItToTransaction(entityGuid: any, transactionDataIO: any, serviceTask: any, taskId: any, selectedProduct) {
    this.policyService.getCaseByGuid(entityGuid).
      subscribe(resp => {
        if (resp && Object.entries(resp).length > 0) {
          transactionDataIO = resp;
          let inboxType = this._inboxType
          this.interactService.sendIOToTransaction(serviceTask,this.productFamilyCd, selectedProduct, 'SINGLELIFE', transactionDataIO, taskId, null, inboxType);
          this.router.navigate(['/app/nbu/transaction/details'], { queryParams: {}, replaceUrl: false });
        }
        else {
          this.message.error("SERVER ERROR - Technical issue occurred, please contact IT Support.")
        }
      });
    return transactionDataIO;
  }

  treeClick(data: any) {
    this.resetPageNumber();
    if (data && data.node && data.node.isLeaf) {
      if (this.inboxViewName == 'TEAMLEADTASK') {
        if (data.keys && data.keys.length > 0)
          var me = this;
        this.workQueueService.getTaskList(data.keys[0])
          .subscribe(jsonResp => {
            if (jsonResp && (Array.isArray(jsonResp) || Object.entries(jsonResp).length > 0)) {
              this.workQueueAPIResponse = jsonResp || [];
              this.setServerDateToUIDateFormat();
              this.stopListLoader();
            }
            else {
              this.message.warning("The system is currently processing. Please try again shortly. If the issue persists, contact IT Support.", { nzDuration: 1500 });
            }
          })
      } else if (this.inboxViewName == 'INDIVIDUAL') {
        if (this.inboxFolders && this.inboxFolders.length && data.node.parentNode && this.filteredClaims[data.node.parentNode.key] && this.filteredClaims[data.node.parentNode.key]['children'] && this.filteredClaims[data.node.parentNode.key]['children'][data.node.key]) {
          this.workQueueAPIResponse = this.filteredClaims[data.node.parentNode.key]['children'][data.node.key].filteredClaims
        }
        else if (this.inboxFolders && this.inboxFolders.length && this.filteredClaims[data.node.key]) {
          this.workQueueAPIResponse = this.filteredClaims[data.node.key].filteredClaims
        }
        else {
          this.getFolderData(data.keys[0])
        }
      } else if (this.inboxViewName == 'WORKQUEUEMANAGER') {
        this.getFolderData(data.keys[0])
      }
    }
    else if (data && data.node && !data.node.isLeaf) {
      if (this.inboxFolders && this.inboxFolders.length && this.filteredClaims[data.node.keys]) {
        this.workQueueAPIResponse = this.filteredClaims[data.node.keys].filteredClaims
      }
    }
    else {
      this.message.warning("Click on a folder to view cases.", { nzDuration: 1000 })
    }
  }

  nodes = [];
  nodes_Cases = [];

  startListLoader() {
    this.isLoading = true;
  };

  stopListLoader() {
    this.isLoading = false
  }
  currentUser: any;

  showOrgHierarchy: boolean = false;
  openOrgHierarchyModal() {
    this.showOrgHierarchy = true;
  }
  userName = null;
  timeOfDay: string;

  checkTimeToGreet() {
    const currentTime = moment();
    const earlyMorningTime = moment('4:00:00 AM', 'hh:mm:ss A');
    const afternoonTimeStart = moment('12:00:00 PM', 'hh:mm:ss A');
    const eveningTimeStart = moment('06:00:00 PM', 'hh:mm:ss A');

    if (currentTime.isBetween(earlyMorningTime, afternoonTimeStart)) {
      this.timeOfDay = 'Morning';
    } else if (currentTime.isBetween(afternoonTimeStart, eveningTimeStart)) {
      this.timeOfDay = 'Afternoon';
    } else {
      this.timeOfDay = 'Evening';
    }
  }

  getIndivisualTasks() {
    let userId = null
    userId = this.userInfoService.getUserId();
    var me = this;
    this.currentUser = userId;
    this.workQueueService.getTaskList(userId)
      .subscribe(jsonResp => {
        if (jsonResp && (Array.isArray(jsonResp))) {
          if (this.radioValue == "myCases") {
            this.inboxViewName = 'INDIVIDUAL'
            this.workQueueAPIResponse = jsonResp; //check here
            this.dataSet = this.workQueueAPIResponse;
            this.dataTransformService.notificationCount = jsonResp.length;
            // this.workQueueAPIResponse = this.taskService.setSLA(this.workQueueAPIResponse) || [];
            if (!this.showAllCases) this.getWorkQueData();
            this.getServiceCdAndServiceTaskList(jsonResp);
            this.taskList = [];
          }
          this.setServerDateToUIDateFormat()
          // this.updateTotalCount("individual",this.workbenchTaskCards);
          this.updateCountOfTasks("individual", jsonResp);
          if (this.myCases) {
            this.getImpTasksData();
          }
        }
        else {
          this.message.warning("The system is currently processing. Please try again shortly. If the issue persists, contact IT Support.", { nzDuration: 1500 });
        }
        this.stopListLoader();
        this.disableCasesToggle = false;
        setTimeout(() => {
          this.loadCasesSummaryPanel = false;
        }, 200);
      })
  }

  getImpTasksData() {
    this.impTaskCount['totalCases'] = this.workQueueAPIResponse.length;
    this.impTaskCount['complexTaskCount'] = this.workQueueAPIResponse.filter(item => Number(item.complexityScore) > 6).length;
    this.impTaskCount['priorityTaskCount'] = this.workQueueAPIResponse.filter(item => item.priority == 'High').length;
    this.impTaskCount['SLATaskCount'] = this.workQueueAPIResponse.filter(item => item.level == 'LEVEL3').length;
    this.impTaskCount['missedSLATaskCount'] = this.workQueueAPIResponse.filter(item => item.level == 'LEVEL4').length;
  }

  getUserSubordinateTasks() {
    this.workQueueService.getSubordinateTasks()
      .subscribe(jsonResp => {
        if (jsonResp && (Array.isArray(jsonResp))) {
          if (this.radioValue == "subCases") {
            this.inboxViewName = 'WORKQUEUEMANAGER'
            this.dataSet = this.workQueueAPIResponse;
            this.workQueueAPIResponse = jsonResp;
            if (!this.showAllCases) this.getWorkQueueDataByMAnagerId();
            this.taskList = [];
          }
          this.setServerDateToUIDateFormat()
          this.updateCountOfTasks("subordinate", jsonResp);
          this.stopListLoader()
        }
        this.disableCasesToggle = false;
      })
  }
  getUserTeammateTasks() {
    this.workQueueService.getTeammateTasks()
      .subscribe(jsonResp => {
        if (jsonResp && (Array.isArray(jsonResp))) {
          if (this.radioValue == "teamCases") {
            this.inboxViewName = 'TEAMLEADTASK'
            this.workQueueAPIResponse = jsonResp;
            this.dataSet = this.workQueueAPIResponse;
            this.taskList = [];
            this.getReportedUsers();
          }
          this.setServerDateToUIDateFormat()
          this.updateCountOfTasks("team", jsonResp);
          this.stopListLoader()
        }
        this.disableCasesToggle = false;
      })
  }
  reassignEnable: any;

  updateTotalCount(workbenchTaskCards) {
    let totalCount = 0;
    if (this.commonUtilty.isArrayIterable(workbenchTaskCards)) {
      workbenchTaskCards.forEach(item => {
        if (item.key != 'subordinate') {
          totalCount = totalCount + item.count;
        }
        if (item.key == 'subordinate' && totalCount != item.count) {
          item.count = totalCount;
        }
      })
    }
  }

  updateCountOfTasks(key, resp) {
    this.workbenchTaskCards.forEach(userTasks => {
      if (userTasks.key == key) {
        userTasks.count = this.commonUtilty.isArrayIterable(resp) ? resp.length : 0;
      }
    });
  }

  workbenchTaskCards = [
    {
      label: 'My Cases',
      count: 0,
      img: '/assets/images/ico/profile.png',
      bgColor: '#647c8a',
      key: 'individual'
    },
    {
      label: 'Reportee Cases',
      count: 0,
      img: '/assets/images/ico/team.png',
      bgColor: '#2197f3',
      key: 'team'
    },
    {
      label: 'Work Manager Cases',
      count: 0,
      img: '/assets/images/ico/subordinate.png',
      bgColor: '#3f51b5',
      key: 'subordinate'
    },
  ]

  getWorkQueData() {
    this.nodes_Cases = []
    let roleDO: any = this.userInfoService.getUserRoleDO() || {}
    this.reassignEnable = this.getReassignEnableFlag(roleDO);
    if (!this.inboxFullPrivilege || roleDO.roleId == 'CLAIM_UNDERWRITING' ||
      roleDO.roleId == 'CLAIM_REVIEW_MO' || roleDO.roleId == 'CLAIM_REVIEW_LEGAL' ||
      roleDO.roleId == 'CLAIM_BRANCHINTIMATION' || roleDO.roleId == 'CLAIM_USER' || roleDO.roleId == 'HO') {
      this.workQueueService.getWorkQueues().subscribe(Response => {
        if (Response) {
          this.workques = Response;
          this.setTaskCountForFolder()
        }
      }, errResponse => { })
    }
    else if (roleDO.roleId) {
      this.workQueueService.getWorkQueues().subscribe(Response => {
        if (Response) {
          this.workques = Response;
          this.setTaskCountForFolder()
        }
      }, errResponse => { })
    }
    else {
      this.workQueueService.getAllWorkQueues().subscribe(Response => {
        if (Response) {
          this.workques = Response;
          this.setTaskCountForFolder()
        }
      }, errResponse => { })
    }
  }
  getWorkQueueDataByMAnagerId() {
    this.nodes_Cases = []
    this.workQueueService.getWorkQueuesByManagerId().subscribe(Response => {
      if (Response) {
        this.workques = Response;
        this.setTaskCountForFolder()
      }
    }, errResponse => { })
  }

  filteredClaims = {}
  sortFilteredResults(obj: { [key: string]: FilteredResult }): { [key: string]: FilteredResult } {
    const entries = Object.entries(obj);
    entries.sort(([, a], [, b]) => a.sortOrder - b.sortOrder);
    const sortedObj: { [key: string]: FilteredResult } = {};
    for (const [key, value] of entries) {
      sortedObj[key] = value;
      if (value.children) {
        sortedObj[key].children = this.sortFilteredResults(value.children);
      }
    }

    return sortedObj;
  }
  setTaskCountForFolder() {
    this.nodes = []
    this.nodes_Cases = []

    if (this.inboxFolders && this.inboxFolders.length) {
      this.nodes_Cases = [];
      this.inboxFolders.forEach(folder => {
        let isLeafFl = folder.parentFolderName ? true : false
        if (!isLeafFl) {
          let workQueTreeDO = new ExtraFolderTreeDO();
          workQueTreeDO.key = folder.folderName;
          workQueTreeDO.icon = folder.icon;
          workQueTreeDO.isLeaf = isLeafFl;
          workQueTreeDO.count = 0;
          workQueTreeDO.sortOrder = folder.sortOrder;
          workQueTreeDO.expanded = true;
          workQueTreeDO.title = folder.folderName;
          workQueTreeDO.routeRule = folder.routeRule;
          this.nodes_Cases.push(workQueTreeDO);
        }
      })
      this.inboxFolders.forEach(folder => {
        let isLeafFl = folder.parentFolderName ? true : false
        if (isLeafFl) {
          for (var j = 0; j < this.nodes_Cases.length; j++) {
            if (folder.parentFolderName == this.nodes_Cases[j].key) {
              let workQueTreeDO = new ExtraFolderTreeDO();
              workQueTreeDO.key = folder.folderName;
              workQueTreeDO.icon = folder.icon;
              workQueTreeDO.isLeaf = isLeafFl;
              workQueTreeDO.count = 0;
              workQueTreeDO.sortOrder = folder.sortOrder;
              workQueTreeDO.expanded = true;
              workQueTreeDO.title = folder.folderName;
              workQueTreeDO.routeRule = folder.routeRule;
              this.nodes_Cases[j].children.push(workQueTreeDO);
            }
          }
        }
      })
      console.log('Nodes', this.nodes_Cases)
      this.filteredClaims = this.filterClaims(this.nodes_Cases, this.workQueueAPIResponse);
      console.log("extra folder node before sort = ", this.filteredClaims);
      this.filteredClaims = this.sortFilteredResults(this.filteredClaims)
      console.log("node cases = ", this.nodes_Cases);
      console.log("extra folder node after sort = ", this.filteredClaims);
      this.nodes = this.applyCountToParentNodeForFolders(this.nodes_Cases, this.filteredClaims);
      this.nodes = this.commonUtilty.sortObject('sortOrder', this.nodes, 'asc')
      console.log("nodes = ", this.nodes);
    }
    else {
      let workques
      if (Array.isArray(this.workques))
        workques = this.workques.filter(function (e) { return e != null });
      if (workques && workques.length > 0) {
        workques.forEach(workque => {
          if (workque != undefined && workque != null) {
            var count = 0;
            if (this.workQueueAPIResponse)
              this.workQueueAPIResponse.forEach(element => {
                count += element.workQueue == workque.queueCd ? 1 : 0
              });
            workque.taskCount = count;
          }
        });
      }
      if (workques && workques.length > 0) {
        for (var i = 0; i < workques.length; i++) {
          if (workques[i] != undefined && workques[i] != null && workques[i].parentQueueCd === null) {
            let workQueTreeDO = new WorkQueTreeDO();
            workQueTreeDO.key = workques[i].queueCd;
            workQueTreeDO.expanded = true;
            workQueTreeDO.title = workques[i].queueDesc;
            workQueTreeDO.parentQueueCd = workques[i].parentQueueCd;
            this.nodes_Cases.push(workQueTreeDO)
          }
        }
      }
      if (workques && workques.length > 0) {
        for (var i = 0; i < workques.length; i++) {
          let isLeafFl = this.checkNodeIsLeaf(workques, i, workques[i].queueCd);
          for (var j = 0; j < this.nodes_Cases.length; j++) {
            if (workques[i] != undefined && workques[i] != null) {
              if (workques[i].parentQueueCd == this.nodes_Cases[j].key) {
                let workQueTreeDO = new WorkQueTreeDO();
                workQueTreeDO.key = workques[i].queueCd;
                if (isLeafFl)
                  workQueTreeDO.icon = workques[i].icon;
                workQueTreeDO.isLeaf = isLeafFl;
                workQueTreeDO.count = workques[i].taskCount
                workQueTreeDO.title = workques[i].queueDesc
                this.nodes_Cases[j].children.push(workQueTreeDO);
              }
            }
            for (var k = 0; k < this.nodes_Cases[j].children.length; k++) {
              if (workques[i] != undefined && workques[i] != null) {
                if (workques[i].parentQueueCd == this.nodes_Cases[j].children[k].key) {
                  let workQueTreeDO = new WorkQueTreeDO();
                  workQueTreeDO.key = workques[i].queueCd;
                  if (isLeafFl)
                    workQueTreeDO.icon = workques[i].icon;

                  workQueTreeDO.isLeaf = isLeafFl;
                  workQueTreeDO.count = workques[i].taskCount
                  workQueTreeDO.title = workques[i].queueDesc
                  this.nodes_Cases[j].children[k].children.push(workQueTreeDO);
                }
              }
            }
          }
        }
      }
      this.nodes = this.applyCountToParentNode(this.nodes_Cases);
      this.nodes = this.commonUtilty.sortObject('sortOrder', this.nodes, 'asc')
    }
  }

  inboxFolders = null
  setExtraFolderWorkqueue() {
    this.workQueueService.getInboxFolders().subscribe(Response => {
      if (Response) {
        this.inboxFolders = Response.inboxFolderConfigs ? Response.inboxFolderConfigs : [];
        console.log("Inbox extra folders list = ", this.inboxFolders);
      }
    }, errResponse => { })
  }

  parseRouteRule(routeRule: string | null): any[] {
    if (!routeRule) {
      return [];
    }
    const operators = /(==|!=|>=|<=|>|<|AND|OR|=)/;
    return routeRule.split(operators).map(part => part.trim()).filter(part => part.length > 0);
  }

  applyFolderCounts(filterClaims, node, parentIndex?) {
    if (parentIndex != null) {
      if (node && node.children && node.children[parentIndex] && node.key && filterClaims[node.key] && filterClaims[node.key].children && filterClaims[node.key].children[node.children[parentIndex].key] && filterClaims[node.key].children[node.children[parentIndex].key].filteredClaims && filterClaims[node.key].children[node.children[parentIndex].key].filteredClaims.length) {
        node.children[parentIndex].count = filterClaims[node.key].children[node.children[parentIndex].key].filteredClaims.length;
      }
      else node.children[parentIndex].count = 0;
      if (node.children[parentIndex].count === 0) {
        node.children[parentIndex].disabled = true
      }
    }
    else {
      if (node.key && filterClaims[node.key] && filterClaims[node.key].filteredClaims && filterClaims[node.key].filteredClaims.length) {
        node.count = filterClaims[node.key].filteredClaims.length;
      }
      else node.count = 0;
      if (node.count === 0) {
        node.disabled = true
      }
    }
    return node
  }

  applyCountToParentNode(nodes) {
    if (nodes && Array.isArray(nodes)) {
      nodes.forEach(WorkQueTreeDO => {
        let totalCount = 0
        if (WorkQueTreeDO.children && Array.isArray(WorkQueTreeDO.children) && WorkQueTreeDO.children.length) {
          WorkQueTreeDO.children.forEach(workQueChild => {
            let childCount = this.workQueueAPIResponse.filter(resp => workQueChild.key == resp.workQueue)
            workQueChild.count = childCount.length
            workQueChild['title'] = `${workQueChild['title']} (${workQueChild.count})`
            totalCount += workQueChild.count
            if (workQueChild.count === 0) {
              workQueChild.disabled = true
            }
          })
        }

        let parentCount
        if (totalCount != 0)
          WorkQueTreeDO['count'] = totalCount
        else {
          parentCount = this.getParentCount(parentCount, WorkQueTreeDO);
          WorkQueTreeDO.count = parentCount.length
          totalCount = WorkQueTreeDO.count
        }

        WorkQueTreeDO = this.setCountIconAndDisableForWorkqueue(totalCount, WorkQueTreeDO);
      })
    }

    return nodes
  }

  applyCountToParentNodeForFolders(nodes, filterClaims) {
    if (nodes && Array.isArray(nodes)) {
      nodes.forEach(WorkQueTreeDO => {
        let totalCount = 0
        if (WorkQueTreeDO.children && Array.isArray(WorkQueTreeDO.children) && WorkQueTreeDO.children.length) {
          WorkQueTreeDO.children.forEach((workQueChild, i) => {
            if (!workQueChild.routeRule) {
              let childCount = this.workQueueAPIResponse.filter(resp => workQueChild.key == resp.workQueue)
              workQueChild.count = childCount.length
              workQueChild['title'] = `${workQueChild['title']} (${workQueChild.count})`
              totalCount += workQueChild.count
              if (workQueChild.count === 0) {
                workQueChild.disabled = true
              }
            }
            else {
              WorkQueTreeDO = this.applyFolderCounts(filterClaims, WorkQueTreeDO, i);
              workQueChild['title'] = `${workQueChild['title']} (${workQueChild.count})`
              totalCount += workQueChild.count
            }
          })
        }
        else if (WorkQueTreeDO && WorkQueTreeDO.routeRule) {
          WorkQueTreeDO = this.applyFolderCounts(filterClaims, WorkQueTreeDO);
          totalCount += WorkQueTreeDO.count;
        }
        else {
          if (filterClaims && filterClaims[WorkQueTreeDO.key] && filterClaims[WorkQueTreeDO.key].filteredClaims && filterClaims[WorkQueTreeDO.key].filteredClaims.length)
            totalCount += filterClaims[WorkQueTreeDO.key].filteredClaims.length;
          else totalCount += WorkQueTreeDO.count;
        }

        let parentCount
        if (totalCount != 0)
          WorkQueTreeDO['count'] = totalCount
        else {
          parentCount = this.getParentCount(parentCount, WorkQueTreeDO);
          WorkQueTreeDO.count = parentCount.length
          totalCount = WorkQueTreeDO.count
        }

        WorkQueTreeDO = this.setCountIconAndDisableForWorkqueue(totalCount, WorkQueTreeDO);
      })
    }

    return nodes
  }

  private setCountIconAndDisableForWorkqueue(totalCount: number, WorkQueTreeDO: any) {
    if (totalCount == 0) {
      WorkQueTreeDO.expanded = false;
      WorkQueTreeDO.isLeaf = true;
      if (WorkQueTreeDO.key != 'CLM_PENDING_REQ' && WorkQueTreeDO.key != 'CLM_PENDING_REFER' && WorkQueTreeDO.key != 'CLM_PENDING_LA_GA') {
        WorkQueTreeDO.disabled = true;
        WorkQueTreeDO['title'] = `${WorkQueTreeDO['title']} (${totalCount})`;
        WorkQueTreeDO.icon = WorkQueTreeDO.icon ? WorkQueTreeDO.icon : 'minus-circle';
      }
      else {
        WorkQueTreeDO.disabled = false;
        WorkQueTreeDO['title'] = `${WorkQueTreeDO['title']}`;
        WorkQueTreeDO.icon = 'folder-open';
      }
    }
    else {
      WorkQueTreeDO.isLeaf = this.commonUtilty.isArrayIterable(WorkQueTreeDO.children) ? false : true;
      if (WorkQueTreeDO.key == 'All Cases') {
        WorkQueTreeDO['title'] = `${WorkQueTreeDO['title']} (${totalCount})`;
        WorkQueTreeDO.icon = WorkQueTreeDO.icon ? WorkQueTreeDO.icon : 'profile';

      } else if (WorkQueTreeDO.key == 'Pending Requirements') {
        WorkQueTreeDO['title'] = `${WorkQueTreeDO['title']} (${totalCount})`;
        WorkQueTreeDO.icon = WorkQueTreeDO.icon ? WorkQueTreeDO.icon : 'clock-circle';

      } else if (WorkQueTreeDO.key == 'SLA Breached Cases') {
        WorkQueTreeDO['title'] = `${WorkQueTreeDO['title']} (${totalCount})`;
        WorkQueTreeDO.icon = WorkQueTreeDO.icon ? WorkQueTreeDO.icon : 'field-time';
      } else if (WorkQueTreeDO.key == 'Draft') {
        WorkQueTreeDO['title'] = `${WorkQueTreeDO['title']} (${totalCount})`;
        WorkQueTreeDO.icon = WorkQueTreeDO.icon ? WorkQueTreeDO.icon : 'file';
      }
      else {
        WorkQueTreeDO['title'] = `${WorkQueTreeDO['title']} (${totalCount})`;
        WorkQueTreeDO.icon = WorkQueTreeDO.icon ? WorkQueTreeDO.icon : 'file-done';
      }
    }
    return WorkQueTreeDO
  }

  private getParentCount(parentCount: any, WorkQueTreeDO: any) {
    parentCount = this.workQueueAPIResponse.filter(resp => WorkQueTreeDO.key == resp.workQueue);
    if (WorkQueTreeDO.key == 'CLM_PENDING_REQ' || WorkQueTreeDO.key == 'PENDING_REQUIREMENT' || WorkQueTreeDO.key == 'Pending Requirements') {
      parentCount = this.workQueueAPIResponse.filter(resp => resp.pendingReqFl == "true" || resp.pendingReqFl == true);
    }
    if (WorkQueTreeDO.key == 'CLM_PENDING_REFER' || WorkQueTreeDO.key == 'PENDING_REFERRAL') {
      parentCount = this.workQueueAPIResponse.filter(resp => resp.pendingTaskFl == "true" || resp.pendingTaskFl == true);
    }
    if (WorkQueTreeDO.key == 'SLA_BREACH_CASES' || WorkQueTreeDO.key == 'SLA Breached Cases') {
      parentCount = this.workQueueAPIResponse.filter(resp => resp.slaBreach == "Y");
    }
    return parentCount;
  }

  checkNodeIsLeaf(workques, index, queueCd) {
    for (var i = 0; i < workques.length; i++) {
      if (i != index) {
        if (workques[i] != undefined && workques[i] != null) {
          if (workques[i].parentQueueCd != null && workques[i].parentQueueCd != undefined && queueCd) {
            if (queueCd == workques[i].parentQueueCd) {
              return false;
            }
          }
        }
      }
    }
    return true;
  }

  pageNumber = 1
  itemsPerPage = 10
  totalitems
  getPageWiseInboxItems(workQueue?) {
    let queue = workQueue && workQueue.length > 0 ? workQueue : this.workQueueAPIResponse
    let transformedQueue: Array<any> = this.commonUtilty.deepCopy(queue);
    if (transformedQueue && Array.isArray(transformedQueue) && this.appMetadataHandler.featureFlags.enablePaginationOnInbox) {
      transformedQueue = this.toFilterWorkTask(queue);
      this.totalitems = transformedQueue.length
      let _chunks = this.arrayManipulations.chunkArray(transformedQueue, this.itemsPerPage)
      let pageToArrayIndex = this.pageNumber - 1;
      return of(_chunks[pageToArrayIndex])
    }
    else if (!this.appMetadataHandler.featureFlags.enablePaginationOnInbox) {
      return of(queue)
    }
  }

  setCurrentPageNumber(currentPageNum) {
    this.isLoading = true
    this.pageNumber = currentPageNum
    setTimeout(() => {
      this.isLoading = false
    }, 100);

  }

  setItemsPerPage(itemsPerPage) {
    this.isLoading = true
    this.itemsPerPage = itemsPerPage
    setTimeout(() => {
      this.isLoading = false
    }, 100);
  }

  getReportedUsers() {
    var me = this;
    this.nodes_Cases = []
    this.workQueueService.getReportedUsers()
      .subscribe(jsonResp => {
        if (jsonResp) {
          let teamusers = jsonResp;
          if (teamusers && teamusers.length > 0) {
            teamusers.forEach(teamuser => {
              var count = 0;
              if (this.workQueueAPIResponse)
                this.workQueueAPIResponse.forEach(element => {
                  count += element.taskUser == teamuser.userId ? 1 : 0
                });
              teamuser.taskCount = count;
            })
          }
          if (teamusers.length > 0) {
            for (let i = 0; i < teamusers.length; i++) {
              let workQueTreeDO = new WorkQueTreeDO();
              workQueTreeDO.key = teamusers[i].userId;
              workQueTreeDO.icon = teamusers[i].icon;
              workQueTreeDO.isLeaf = true;
              workQueTreeDO.title = teamusers[i].firstName + " (" + teamusers[i].taskCount + ")";
              this.nodes_Cases.push(workQueTreeDO)
            }
          }
          this.nodes = this.nodes_Cases;
        }
      }, (errResponse) => {
        console.log(errResponse)
      })
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      const momentFormat = this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR.replace('dd', 'DD').replace('yyyy', 'YYYY');
      dateString = moment(rawDate).format(momentFormat);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }
  externalParam = [
  {
    "paramName": "userId",
    "paramValue": this.userInfoService.getUserId()
  },
  {
    "paramName": "viewName",
    "paramValue": "INDIVIDUAL"
  }]
  onChangeOfTaskType(event) {
    let indexOfViewName = this.externalParam.findIndex(item => item.paramName == "viewName")
    if (event) {
      if (event == 'myCases') {
        this.externalParam[indexOfViewName]['paramValue'] = 'INDIVIDUAL'
      }
      if (event == 'teamCases') {
        this.externalParam[indexOfViewName]['paramValue'] = 'TEAMLEADTASK'
      }
      if (event == 'subCases') {
        this.externalParam[indexOfViewName]['paramValue'] = 'WORKQUEUEMANAGER'
      }
    }
  }

  getWorkBenchSearchCriteriaList() {
    this.metadataService.fetchAPIMetaData('searchInboxNbu')
      .subscribe(jsonResp => {
        if (jsonResp && Array.isArray(jsonResp)) {
          jsonResp.forEach(criteria => {
            let searchCriteriaDO = new SearchAPIMetaDataDO();
            searchCriteriaDO.key = criteria.attributeName;
            searchCriteriaDO.keyDescription = criteria.description;
            searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            searchCriteriaDO.lookupName = criteria.attributeLookupCd;
            searchCriteriaDO.defaultFl = criteria.defaultFl;
            searchCriteriaDO.lookup = [];
            searchCriteriaDO.enable = true;
            searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            this.CRITERIALOOKUP.push(searchCriteriaDO)
          })
        }
      })
  }
  public getFolderData(queueCd): void {
    this.inboxSortService.setSortCondition(queueCd);
  }
  setServerDateToUIDateFormat() {
    if (this.workQueueAPIResponse && Array.isArray(this.workQueueAPIResponse))
      this.workQueueAPIResponse.forEach(element => {
        element.eventDt = this.getDateString(element.eventDt)
      });
  }

  taskList: any = []
  taskSubject$
  selectedItems = []
  refreshReassingTaskList() {
    if (this.taskSubject$)
      this.taskSubject$.unsubscribe()
    this.taskList = [];
    this.taskSubject$ = this.interactService.taskSubject$.subscribe(res => {
      if (res && res.data) {

        if (res.event) {
          let indexFound = this.taskList.findIndex(item => {
            if (item.id && item.proposalNum && res.data && res.data.id && res.data.proposalNum)
              return (item.id === res.data.id) && (item.proposalNum == res.data.proposalNum);
          })
          if (indexFound === -1) {
            this.taskList.push(res.data)
          }
        }
        else {

          let output = this.taskList.filter(item => {
            if (item.id && item.proposalNum && res.data && res.data.id && res.data.proposalNum)
              return item.id !== res.data.id && item.proposalNum !== res.data.proposalNum;
          }) || []
          this.taskList = output;
        }
      }
    })
  }
  showAssignModal() {
    if (this.taskList.length == 0)
      this.notification.warning('No data selected', 'Please select at least one task.');
    else
      this.modShowReassign = true;
  }
  
  /* searching and sorting*/
  dataView = 'cards-layout'
  searchValue = null;
  setDataView(view) {
    this.dataView = view
  }

  selectedTaskRequired: boolean = false;
  numberOfChecked = 0;

  sortTaskRequired = true;
  workTaskFetched: boolean = true;
  fieldSelectedFilter: string;
  cardMetaData: Array<any> = [];

  isAscendingSort: boolean = null;
  isDescendingSort: boolean = null;

  taskOperationButtonRequired: boolean = true;

  toFilterWorkTask(queue) {
    if (!this.fieldSelectedFilter)
      return queue;
    else if (this.isAscendingSort)
      return this.orderByPipe.transform(queue, this.fieldSelectedFilter,true)
    else if (this.isDescendingSort)
      return this.orderByPipe.transform(queue, this.fieldSelectedFilter,false)
    else
      return queue;
  }

  sortInAscending() {
    this.isDescendingSort = null;
    this.isAscendingSort = this.isAscendingSort==null ? true : null;
  }

  sortInDescending() {
    this.isAscendingSort = null;
    this.isDescendingSort = this.isDescendingSort==null ? true : null;
  }

  getEarlyNonEarlyString(rawData) {
    if (rawData == "true" || rawData == true)
      return of('Early').pipe(take(1));
    else
      return of('Non Early').pipe(take(1));
  }

  selectedUserLookup: any;
  userList() {
    let selectedUserGuid
    let selectedUserServiceTask

    if (this.commonUtilty.isArrayIterable(this.taskList)) {
      selectedUserGuid = this.taskList[0].guid;
      selectedUserServiceTask = this.taskList[0].serviceTask
      this.workQueueService.getUserList(selectedUserGuid, selectedUserServiceTask).subscribe(resp => {
        if (resp) {
          this.selectedUserLookup = resp;
          console.log('selectedUser', resp);
        }
      })
    }
  }

  getReassignEnableFlag(roleDO) {
    this.workQueueService.getUserRoleList().subscribe(resp => {
      if (this.commonUtilty.isArrayIterable(resp) && roleDO) {
        resp.forEach(user => {
          if (user.roleCd == roleDO.roleId) {
            return user.isReassignEnabled;
          }
        })
      }
    })
  }
  getDaysInYear(days) {
    return of(this.commonUtilty.humanizeNumberOfMonths(days)).pipe(take(1));
  }

  inboxConfigModal: boolean = false;
  inboxConfiguration() {
    this.dataTransformService.enablePersonalizedInboxModal = true;
  }

  refreshInboxToggle = true
  _toggleRefreshInbox() {
    this.refreshInboxToggle = false;
    setTimeout(() => {
      this.refreshInboxToggle = true;
      this.stopListLoader();
    }, 300);
  }


  //  search and sort table
  filterKey = null;
  public dataSet = [];
  getConfigKey(key) {
    this.filterKey = key;
    console.log("config key", key);
  }

  search(value) {
    if (value) {
      let column = this.inboxGridLayoutSuperSet.filter(column => column.dataKey == this.filterKey);
      if(column && column.length && column[0]){
        let config = column[0]
        this.workQueueAPIResponse = this.dataSet.filter(data => {
          if (config.uiTypeCd == 'DATE') {
            // TODO
            return this.getDateString(data[config.dataKey]).toLowerCase().includes(value.toLowerCase())
          } else {
            if(data[config.dataKey] && isNaN(data[config.dataKey])) {
              return typeof data[config.dataKey] == 'string' && data[config.dataKey].toLowerCase().includes(value.toLowerCase());
            }
            else{
              return data[config.dataKey].toLowerCase().includes(value);
            }
          }
        });
      }
      else {this.workQueueAPIResponse = this.commonUtilty.deepCopy(this.dataSet); }
      // if (!this.commonUtilty.isArrayIterable(this.dataSet)) {
      //   this.intimationZeroState.title = "No results found"
      //   this.intimationZeroState.message = "No records matched with this query."
      // }
    }
  }

  sortName: string | null = null;
  sortValue: string | null = null;

  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;

    if (this.sortName && this.sortValue) {
      let orderBy = this.sortValue === 'ascend' ? 'asc' : 'desc';
      this.workQueueAPIResponse = this.commonUtilty.deepCopy(this.commonUtilty.sortObject(this.sortName, this.workQueueAPIResponse, orderBy))
    } else {
      this.workQueueAPIResponse = this.dataSet;
    }
    console.log("sorted searchResultsList", JSON.stringify(this.workQueueAPIResponse));
  }

  reloadInbox() {
    this.startListLoader();
    this._toggleRefreshInbox();
    console.log(this.inboxDataPointsDefaultSet);
  }


  selectAllAttributes() {
    this.inboxDataPointsDefaultSet = [...this.inboxDataPointsDefaultSet, ...this.inboxDataPointsSuperSet];
    this.setFilteredMetaDataMap();
    this.inboxDataPointsSuperSet = [];
  }

  setFilteredMetaDataMap() {
    this.filteredMetaDataMap = Object.assign([], this.inboxDataPointsDefaultSet).filter(
      item => item.isVisible == true
    )
  }


  moveAttributeUpOrDown(currentIndex, direction) {
    if (direction == 'UP') this.swapAttributes(currentIndex, currentIndex - 1);
    else if (direction == 'DOWN') this.swapAttributes(currentIndex, currentIndex + 1);
  }

  swapAttributes(firstIndex, secondIndex) {
    let tempIdx = this.inboxDataPointsDefaultSet[firstIndex];
    this.inboxDataPointsDefaultSet[firstIndex] = this.inboxDataPointsDefaultSet[secondIndex];
    this.inboxDataPointsDefaultSet[secondIndex] = tempIdx;
    this.setFilteredMetaDataMap();
  }
  /*END - Select ALL - Filter Bar on Workbench*/

  transformQueue(transformedQueue) {
    let tempQueue = transformedQueue.reduce((acc, curr) => {
      let fieldData = [];
      this.appMetadataHandler.inboxCardMetaData['default'].forEach(field => {
        if (field['excelField']) {
          if (field['dataKey'] == "earlyClaimFl")
            this.getEarlyNonEarlyString(field['dataKey']).subscribe(resp => curr[field['dataKey']] = resp)

          if (field['dataKey'] == "commencementDt" || field['dataKey'] == "eventDt" || field['dataKey'] == "expiryDt" || field['dataKey'] == "intimationDt" || field['dataKey'] == "startDt")
            curr[field['dataKey']] = this.getDateString(curr[field['dataKey']]);

          if (field['dataKey'] == "policyAgeInDays")
            this.getDaysInYear(curr[field['dataKey']]).subscribe(resp => curr[field['dataKey']] = resp);

          if (field['pipe'] == "CurrencyFormatter")
            curr[field['dataKey']] = this.currencyFormatterPipe.transform(curr[field['dataKey']]);

          if (field['pipe'] == "technicalTranslate")
            curr[field['dataKey']] = this.technicalTranslate.transform(curr[field['dataKey']]);

          if (field['pipe'] == "technicalTranslate" && field['pipeValue'])
            curr[field['dataKey']] = this.technicalTranslate.transform(curr[field['dataKey']], field['pipeValue'] ? field['pipeValue'] : null)

          fieldData.push(curr[field['dataKey']] ? curr[field['dataKey']] : "-");
        }
      });
      acc.push(fieldData);
      return acc;
    }, []);
    return this.commonUtilty.deepCopy(tempQueue);
  }

  //Template Downloader
  createTemplateExcel() {
    let wb = XLSX.utils.book_new();
    let searchHeader = this.appMetadataHandler.inboxCardMetaData.default.map(field => field['excelField'] ? field.description : null);
    searchHeader = searchHeader.filter(field => field);
    let searchData = this.transformQueue(this.workQueueAPIResponse);
    let templateHeaders = searchHeader;
    let templateFileName = "Workbench Data";
    wb.Props = {
      Title: templateFileName,
      Subject: "Insurance",
      Author: "MetaMorphoSys",
      CreatedDate: new Date()
    };
    wb.SheetNames.push(templateFileName);
    let ws_data = [[...templateHeaders], ...searchData];
    let ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets[templateFileName] = ws;
    let wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
    let xlFile = new Blob([this.sheetToArrayBuffer(wbout)], { type: "application/octet-stream" });
    this.downloadExcelFile(xlFile, `${templateFileName}.xlsx`);
  }

  sheetToArrayBuffer(wbout) {
    let buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
    let view = new Uint8Array(buf);  //create uint8array as viewer
    for (let i = 0; i < wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet
    return buf;
  }

  downloadExcelFile(blob: any, filename: string): boolean {
    if (!filename) filename = 'file.xlsx';
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.href = url;
    a.download = filename;
    a.target = "_blank";
    a.click();
    URL.revokeObjectURL(a.href);
    return true;//url;
  }

  personalizedInboxUserJSON: any = {}
  personalizedInboxroleCdJson: any = {}
  privilegeCd: string = 'Inbox';
  LOB = "LIFE"
  inboxGridLayoutSuperSet = [];
  personalisedInboxDetailsFetch() {
    if (this.dataTransformService.serviceTaskCdList && Array.isArray(this.dataTransformService.serviceTaskCdList)) {
      this.dataTransformService.serviceTaskCdList.forEach(t => {
        this.personalisedInobxService.fetchPersonalizedDataBasedOnEntityRoleCdServiceTask(t.entityCd, t.serviceTask).subscribe((res: any) => {
          if (res && res.inboxCardCfgs && this.commonUtilty.isArrayIterable(res.inboxCardCfgs)) {
            res.inboxCardCfgs.forEach(entityWiseList => {
              if (entityWiseList.dataPointCfgs && this.commonUtilty.isArrayIterable(entityWiseList.dataPointCfgs) && entityWiseList.dataPointCfgs.length) {
                entityWiseList.dataPointCfgs = this.commonUtilty.deepCopy(this.commonUtilty.sortObject('sortOrder', entityWiseList.dataPointCfgs, 'asc'))
                entityWiseList.dataPointCfgs.forEach(dataPoint => {
                  if (this.personalizedInboxroleCdJson[t.serviceTask]) {
                    this.personalizedInboxroleCdJson[t.serviceTask] = entityWiseList;
                    this.personalizedInboxroleCdJson[t.serviceTask]['dataPoints'] = this.commonUtilty.uniquePushInArray(this.personalizedInboxroleCdJson[t.serviceTask]['dataPoints'], dataPoint, "dataKey")
                  }
                  else {
                    this.personalizedInboxroleCdJson[t.serviceTask] = {}
                    this.personalizedInboxroleCdJson[t.serviceTask] = entityWiseList;
                    this.personalizedInboxroleCdJson[t.serviceTask]['dataPoints'] = this.commonUtilty.uniquePushInArray(this.personalizedInboxroleCdJson[t.serviceTask]['dataPoints'], dataPoint, "dataKey")
                  }
                })
              }
              else {

              }
            })
          }
          else {
            if (this.personalizedInboxroleCdJson[t.serviceTask]) {
              this.personalizedInboxroleCdJson[t.serviceTask]['entityCd'] = t.entityCd;
              this.personalizedInboxroleCdJson[t.serviceTask]['dataPoints'] = []
            }
            else {
              this.personalizedInboxroleCdJson[t.serviceTask] = {}
              this.personalizedInboxroleCdJson[t.serviceTask]['entityCd'] = t.entityCd;
              this.personalizedInboxroleCdJson[t.serviceTask]['dataPoints'] = []
            }
          }
          console.log("entity and serviceTask =", t.entityCd, t.serviceTask)
          console.log(" personalizedInboxroleCdJson =", this.personalizedInboxroleCdJson);
          this._toggleRefreshInbox();
        },
          (error) => {
            this.message.warning('Unable to retrieve personalized inbox details. Please try again.', { nzDuration: 1500 });
          })
        this.personalisedInobxService.fetchPersonalizedDataBasedOnEntityRoleCdServiceTaskUserId(t.entityCd, t.serviceTask).subscribe((res: any) => {
          if (res && res.inboxCardCfgs && this.commonUtilty.isArrayIterable(res.inboxCardCfgs)) {
            res.inboxCardCfgs.forEach(entityWiseList => {
              if (entityWiseList.dataPointCfgs && this.commonUtilty.isArrayIterable(entityWiseList.dataPointCfgs) && entityWiseList.dataPointCfgs.length) {
                entityWiseList.dataPointCfgs = this.commonUtilty.deepCopy(this.commonUtilty.sortObject('sortOrder', entityWiseList.dataPointCfgs, 'asc'))
                entityWiseList.dataPointCfgs.forEach(dataPoint => {
                  if (this.personalizedInboxUserJSON[t.serviceTask]) {
                    this.personalizedInboxUserJSON[t.serviceTask]= entityWiseList;
                    this.personalizedInboxUserJSON[t.serviceTask]['dataPoints'] = this.commonUtilty.uniquePushInArray(this.personalizedInboxUserJSON[t.serviceTask]['dataPoints'], dataPoint, "dataKey")
                  }
                  else {
                    this.personalizedInboxUserJSON[t.serviceTask] = {}
                    this.personalizedInboxUserJSON[t.serviceTask] = entityWiseList;
                    this.personalizedInboxUserJSON[t.serviceTask]['dataPoints'] = this.commonUtilty.uniquePushInArray(this.personalizedInboxUserJSON[t.serviceTask]['dataPoints'], dataPoint, "dataKey")
                  }
                })
              }
              else {
                if (this.personalizedInboxUserJSON[t.serviceTask]) {
                  this.personalizedInboxUserJSON[t.serviceTask]['entityCd'] = t.entityCd;
                  this.personalizedInboxUserJSON[t.serviceTask]['dataPoints'] = []
                }
                else {
                  this.personalizedInboxUserJSON[t.serviceTask] = {}
                  this.personalizedInboxUserJSON[t.serviceTask]['entityCd'] = t.entityCd;
                  this.personalizedInboxUserJSON[t.serviceTask]['dataPoints'] = []
                }
              }
            })
          }
          else {
            if (this.personalizedInboxUserJSON[t.serviceTask]) {
              this.personalizedInboxUserJSON[t.serviceTask]['entityCd'] = t.entityCd;
              this.personalizedInboxUserJSON[t.serviceTask]['dataPoints'] = []
            }
            else {
              this.personalizedInboxUserJSON[t.serviceTask] = {}
              this.personalizedInboxUserJSON[t.serviceTask]['entityCd'] = t.entityCd;
              this.personalizedInboxUserJSON[t.serviceTask]['dataPoints'] = []
            }
          }
          console.log(" personalizedInboxUserJSON =", this.personalizedInboxUserJSON);
          this._toggleRefreshInbox();
        },
          (error) => {
            this.message.warning('Unable to retrieve personalized inbox details. Please try again.', { nzDuration: 1500 });
          })
        this._toggleRefreshInbox();
      })
      this.mapApiDataToFields(this.personalizedInboxUserJSON);
      this.applyMetaDataConfigurations()
      this.setInboxCardMetaData();

      // })
    }
  }

  mapApiDataToFields(menuDataList) {
    if (menuDataList && this.commonUtilty.isArrayIterable(menuDataList) && menuDataList.length) {
      this.inboxDataPointsDefaultSet = menuDataList;
    }
  }

  applyMetaDataConfigurations() {
    if (this.inboxDataPointsDefaultSet && this.commonUtilty.isArrayIterable(this.inboxDataPointsDefaultSet) && this.inboxDataPointsDefaultSet.length) {
      this.inboxDataPointsDefaultSet.forEach(field => {
        let JSONfieldDetails = this.appMetadataHandler.inboxCardMetaData.default.filter(item => item['dataKey'] == field.key);
        if (JSONfieldDetails && JSONfieldDetails.length && JSONfieldDetails[0]) {
          field['searchFilter'] = JSONfieldDetails[0]['searchFilter'] ? JSONfieldDetails[0]['searchFilter'] : false
          field['sortFilter'] = JSONfieldDetails[0]['sortFilter'] ? JSONfieldDetails[0]['sortFilter'] : false
          field['pipe'] = JSONfieldDetails[0]['pipe']
          field['date'] = JSONfieldDetails[0]['date'] ? JSONfieldDetails[0]['date'] : false
          field['formatter'] = JSONfieldDetails[0]['formatter'] ? JSONfieldDetails[0]['formatter'] : false
          field['ignoreTechnicalTranslate'] = JSONfieldDetails[0]['ignoreTechnicalTranslate'] ? JSONfieldDetails[0]['ignoreTechnicalTranslate'] : false
        }
      })
    }
  }

  inboxCardFields = [
    {
      "key": "proposalNum",
      "description": "Policy No",
      "isVisible": true,
      "isSelected": false,
      "ignoreTechnicalTranslate": true
    },
    {
      "key": "policyOwner",
      "description": "Policy Owner",
      "isVisible": false,
      "isSelected": false
    },
    {
      "key": "intimationNum",
      "description": "Intimation Number",
      "isVisible": true,
      "isSelected": false,
      "ignoreTechnicalTranslate": true
    },
    {
      "key": "commencementDt",
      "description": "Commencement Date",
      "isVisible": true,
      "isSelected": false
    },
    {
      "key": "insuredName",
      "description": "Insured Name",
      "isVisible": true,
      "isSelected": false
    }
    ,
    {
      "key": "benefitAmt",
      "description": "Benefit Amount",
      "isVisible": true,
      "type": "currency",
      "isSelected": false
    }
    ,
    {
      "key": "earlyClaimFl",
      "description": "Early/Non Early",
      "isVisible": true,
      "isSelected": false
    },
    {
      "key": "policyAgeInDays",
      "description": "Policy Duration",
      "isVisible": true,
      "isSelected": false
    },
    {
      "key": "status",
      "description": "Status",
      "isVisible": true,
      "isSelected": false
    }
  ]

  personalizedFields(data) {
    this.dataTransformService.enablePersonalizedInboxModal = false;
    if (data && data.componentData && data.componentData.inboxCardCfgs.dataPointCfgs
      && this.commonUtilty.isArrayIterable(data.componentData.inboxCardCfgs.dataPointCfgs)
      && data.componentData.inboxCardCfgs.dataPointCfgs.length) {
      this.personalizedInboxUserJSON[data.componentData.inboxCardCfgs.serviceTaskCd] = data.componentData.inboxCardCfgs.dataPointCfgs
    }
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/app/nbu/inbox/workbench']);
    });
  }

  showAllCases = false;
  viewAllCases() {
    this.loadCases(this.radioValue);
    this.showAllCases = !this.showAllCases;
  }

  openAnalyzeModal(status, data) {
    this.analyticsModal = status;
    this.analyticsWorkQueueItemData = data;
  }

  openActivityModal(status, data) {
    this.activityModal = status;
    this.activityWorkQueueItemData = data;
  }

  emitSelectedTask(event, data) {
    this.interactService.sendTaskTOWorkBench(data, event);
  }

  parseExpression(expression: string) {
    return jsep1(expression);
  };

  evaluateExpression(tree: jsep.Expression, item: Claim): any {
    switch (tree.type) {
      case 'Compound':
        if (!tree.body && !this.commonUtilty.isArrayIterable(tree.body)) {
          throw new Error('Compound expression has an empty body');
        }
        let body = this.commonUtilty.deepCopy(tree.body);
        let result = this.evaluateExpression(tree.body[0], item);
        for (let i = 1; i < body.length; i += 2) {
          const operatorNode = tree.body[i];
          const nextExpression = tree.body[i + 1];

          if (!nextExpression) {
            throw new Error('Missing expression after logical operator');
          }

          const operator = operatorNode.name;

          if (operator === 'AND' || operator === 'and') {
            result = result && this.evaluateExpression(nextExpression, item);
          } else if (operator === 'OR' || operator === 'or') {
            result = result || this.evaluateExpression(nextExpression, item);
          } else {
            throw new Error(`Unsupported logical operator: ${operator}`);
          }
        }
        return result;

      case 'BinaryExpression':
        const left = this.evaluateExpression(tree.left as jsep.Expression, item);
        const right = this.evaluateExpression(tree.right as jsep.Expression, item);
        const leftValue = item[left] !== undefined ? item[left] : left;
        const rightValue = item[right] !== undefined ? item[right] : right;

        const parsedLeftValue = this.parseDateIfApplicable(leftValue);
        const parsedRightValue = this.parseDateIfApplicable(rightValue);

        switch (tree.operator) {
          case '==':
            return parsedLeftValue == parsedRightValue;
          case '!=':
            return parsedLeftValue != parsedRightValue;
          case '===':
            return parsedLeftValue === parsedRightValue;
          case '!==':
            return parsedLeftValue !== parsedRightValue;
          case '<':
            return parsedLeftValue < parsedRightValue;
          case '<=':
            return parsedLeftValue <= parsedRightValue;
          case '>':
            return parsedLeftValue > parsedRightValue;
          case '>=':
            return parsedLeftValue >= parsedRightValue;
          case '&&':
          case 'AND':
            return parsedLeftValue && parsedRightValue;
          case '||':
          case 'OR':
            return parsedLeftValue || parsedRightValue;
          default:
            throw new Error(`Unsupported operator: ${tree.operator}`);
        }

      case 'Literal':
        return tree.value;

      case 'Identifier':
        return tree.name;

      default:
        throw new Error(`Unsupported expression type: ${tree.type}`);
    }
  }

  parseDateIfApplicable(value: any): any {
    if (typeof value === 'string' && !isNaN(Date.parse(value))) {
      return new Date(value);
    }
    return value;
  }

fetchProducts(productFamilyCd) {
    this.productData = [];
    this.workQueueService.fetchProducts(productFamilyCd)
      .subscribe(jsonResp => {
        if (jsonResp && jsonResp.length) {
          jsonResp.forEach((criteria: any) => {
            if (criteria && Object.keys(criteria).length) {
              this.productData.push(criteria);
            } else {
              this.productData = [];
            }
          })
        }
        //console.log("product data when fetching from API", JSON.stringify(this.productData));
      })
  }



  parseFilterRule = (rule: FilterRule): ((item: Claim, messages: string[]) => boolean) => {
    if (rule === null) {
      return () => true;
    }

    const expressionTree = this.parseExpression(rule);
    return (item: Claim, messages: string[]) => {
      try {
        return this.evaluateExpression(expressionTree, item);
      } catch (error) {
        messages.push(`Error evaluating rule: ${error.message}`);
        return false;
      }
    };
  };

  filterClaims = (folders: FolderConfig[], claims: Claim[]): { [key: string]: FilteredResult } => {
    const result: { [key: string]: FilteredResult } = {};

    const processFolder = (folder: FolderConfig, claims: Claim[]): FilteredResult => {
      const messages: string[] = [];
      let filteredClaims: Claim[] = [];

      if (folder.key == "All Cases") {
        filteredClaims = claims;
      }
      else if (folder.routeRule) {
        const evaluateFilter = this.parseFilterRule(folder.routeRule);
        filteredClaims = claims.filter(claim => evaluateFilter(claim, messages));
      }

      const children: { [key: string]: FilteredResult } = {};
      let sortOrder: number = folder['sortOrder'] ? folder['sortOrder'] : 0;
      // Process children and add their results to the 'children' object
      if (folder.children && folder.children.length > 0) {
        folder.children.forEach(childFolder => {
          children[childFolder.key] = processFolder(childFolder, claims);
        });
      }

      return {
        filteredClaims,
        messages,
        children,// Now children is correctly typed
        sortOrder
      };
    };

    folders.forEach(folder => {
      result[folder.key] = processFolder(folder, claims);
    });

    return result;
  };

  sortFields;
  fieldsForSorting() {
    this.sortFields = this.appMetadataHandler.inboxCardMetaData.default.filter(item => item['sortFilter']);
  }
  serviceTaskList = []
  serviceCdList = []
  getServiceCdAndServiceTaskList(taskList) {
    if (taskList && (Array.isArray(taskList))) {
      taskList.forEach(task => {
        if (task.serviceTask && task.entityCd) {
          let t = {
            "serviceTask": task.serviceTask,
            "entityCd": task.entityCd,
          }
          this.serviceTaskList = this.commonUtilty.uniquePushInArray(this.serviceTaskList, t, "serviceTask");
        }

      })
    }
    this.dataTransformService.serviceTaskCdList = this.serviceTaskList
    this.personalisedInboxDetailsFetch();
    console.log("serviceCd and serviceTask List = ", this.serviceCdList, this.serviceTaskList)
  }
}
